module.exports = __webpack_public_path__ + "img/nfc-lock.57069eee.svg";